import { render, staticRenderFns } from "./LandingSorteoSection.vue?vue&type=template&id=59f8d579"
import script from "./LandingSorteoSection.vue?vue&type=script&lang=js"
export * from "./LandingSorteoSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports